var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhonesAndFax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "43px",
    viewBox: "0 0 44 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 13") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sales-Pricing-Tool-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-Office-Sales-Tool---Select-Locations-No-Errors-Copy-33",
    transform: "translate(-38.000000, -248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(40.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#FFFFFF",
    x: 0,
    y: 10,
    width: 40,
    height: 30,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#28CAF4",
    x: 18.5,
    y: 26,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#28CAF4",
    x: 24.5,
    y: 26,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#28CAF4",
    x: 30.5,
    y: 26,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#28CAF4",
    x: 18.5,
    y: 30,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#28CAF4",
    x: 24.5,
    y: 30,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#28CAF4",
    x: 30.5,
    y: 30,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#28CAF4",
    x: 18.5,
    y: 34,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#28CAF4",
    x: 24.5,
    y: 34,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#28CAF4",
    x: 30.5,
    y: 34,
    width: 4,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#8D919B",
    x: 9.2,
    y: 11.2,
    width: 1,
    height: 27.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#FFFFFF",
    x: 5,
    y: 7,
    width: 8,
    height: 28,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#28CAF4",
    strokeWidth: 2.4,
    fill: "#FFFFFF",
    x: 17.5,
    y: 14,
    width: 18,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 3.33333333,
    x2: 2.87867966,
    y2: 1.21201299,
    id: "Path-18",
    stroke: "#28CAF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.3333333,
    y1: 3.33333333,
    x2: 15.4546537,
    y2: 1.21201299,
    id: "Path-19",
    stroke: "#28CAF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: 3,
    x2: 9,
    y2: 0,
    id: "Path-17",
    stroke: "#28CAF4",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(18.500000, 26.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(18.500000, 30.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(18.500000, 34.000000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhonesAndFax);
export default __webpack_public_path__ + "static/media/icon-phones-and-fax.5378d5a71d92323295030dc87420e508.svg";
export { ForwardRef as ReactComponent };